import { NetFetch } from '../Net/NetFetch';
import { UnauthorizedError } from './Error/UnauthorizedError';
import { StatusCodes } from './Status/StatusCodes';
/**
 * `/json/sightings/currents/region` client. Returns `null` on
 * non-OK status codes (other than UNAUTHORIZED, which throws). The
 * outer `entry` may be `undefined` when no patch has been fetched yet
 * for the sighting — that's an OK response, not an error.
 */
export class SightingCurrentRegion {
    static async get(sightingId) {
        const result = await NetFetch.postData('/json/sightings/currents/region', { sighting_id: sightingId });
        if (!result || !result.statusCode) {
            return null;
        }
        if (result.statusCode === StatusCodes.UNAUTHORIZED) {
            throw new UnauthorizedError();
        }
        if (result.statusCode !== StatusCodes.OK) {
            return null;
        }
        const raw = result.entry;
        if (raw === undefined) {
            return undefined;
        }
        let grid;
        try {
            grid = JSON.parse(raw.grid_json);
        }
        catch (_a) {
            return null;
        }
        return {
            sighting_id: raw.sighting_id,
            bbox_west: raw.bbox_west,
            bbox_east: raw.bbox_east,
            bbox_south: raw.bbox_south,
            bbox_north: raw.bbox_north,
            grid_step_deg: raw.grid_step_deg,
            grid_n_lat: raw.grid_n_lat,
            grid_n_lon: raw.grid_n_lon,
            grid: grid,
            source: raw.source,
            valid_at: raw.valid_at,
            fetched_at: raw.fetched_at
        };
    }
}
